import { initSpxUi, setSpxThemeMode } from './spx/ui';
import { createSpxApexOptions, initSpxApexCharts, mountSpxApexChart, resolveSpxChartPalette } from './spx/charts';
import { resolveSpxThemeMode } from './spx/ui';

function bootSpxRuntime() {
  initSpxUi();
  initSpxApexCharts();
}

if (typeof window !== 'undefined') {
  window.SchoolPlexDesignSystem = {
    createApexOptions: createSpxApexOptions,
    initApexCharts: initSpxApexCharts,
    mountApexChart: mountSpxApexChart,
    resolveChartPalette: resolveSpxChartPalette,
    resolveThemeMode: resolveSpxThemeMode,
    setThemeMode: setSpxThemeMode,
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      bootSpxRuntime();
    });
  } else {
    bootSpxRuntime();
  }

  window.addEventListener('load', () => {
    initSpxApexCharts();
  });
}
